import { GetPaymentMethodsResponse } from '@vsf-enterprise/adyen-commercetools/lib/types';
import { PAYMENT_METHODS } from '~/constants/paymentMethods';

const hideBilliePaymentMethod = (paymentMethodsResponse: GetPaymentMethodsResponse) => {
  paymentMethodsResponse.paymentMethods = paymentMethodsResponse.paymentMethods.filter(
    paymentMethod => paymentMethod.type !== PAYMENT_METHODS.BILLIE);
};

export default hideBilliePaymentMethod;
